<template>
    <div class="appWrapper">
    <div class="holder">
        <div class="thankyouWrapper">
            <h3>Booking Canceled</h3>
            <p>Your booking has been canceled. We appreciate your interest in the Nissan Adventure Club experience.</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
    return {

    };
  }
};
</script>

<style>

</style>./cancellation.vue